<div class="suspendConfirmation" style='float: left'>
    <div *ngIf="!isSuspending" >
    <button type="button"  title="Suspend" (click)="startSuspend()"><span class="bi bi-pause" style="color:black !important"></span></button>
    </div>
    <div *ngIf="isSuspending">Suspend?
    <button type="button" title="Confirm suspension" (click)="confirm()">Yes</button>
    <button type="button"  title="Cancel suspension" (click)="cancel()" style="width:35px">No</button>
    </div>
    </div>
